/* eslint-disable max-lines */
import { Injectable } from '@angular/core';
import { Control, ControlType, KngCardListState, KngHeaderObjState, KngFilterState, KngHeaderNavMenuOption, ScreenView, SortOrder, GridValue, CtaList, AprRejBtnType, KngButtonState } from 'kinetic-angular';
import { Icons } from './shared-enums';
import { nullCheckValue } from './shared-constants';
import { Image } from './shared-interface';
import { GlobalHeader } from '../../components/main-entry/definitions';
import { UserDetailMiddle } from '../../components/user-management/sub-modules/user-details/definitions/user-detail.interface';
import { SharedFilterFactory } from './shared-filter.factory';

@Injectable({
	providedIn: 'root'
})
export class SharedFactoryDataService 
{
	public static getAccordionCollapsedIcon() 
	{
		return {
			iconPath: '/assets/accordion_collapsed.svg',
			altText: 'Collapsed'
		};
	}
	public static getAccordionExpandedIcon() 
	{
		return {
			iconPath: '/assets/accordion_expanded.svg',
			altText: 'Expanded'
		};
	}
	public static getSearchIcon() 
	{
		return { iconPath: '/assets/search.svg', altText: '' };
	}
	public static getSearchCrossIcon() 
	{
		return {
			iconPath: '/assets/search-cross-icon.svg',
			altText: 'Clear Search'
		};
	}
	public static getServiceManagementStatusCount() 
	{
		return [
			{
				header: 'all',
				label: 'All',
				amount: 0
			},
			{
				header: 'pastDue',
				label: 'Past Due',
				amount: 0
			},
			{
				header: 'upcoming',
				label: 'Upcoming',
				amount: 0
			},
			{
				header: 'open',
				label: 'Open',
				amount: 0
			},
			{
				header: 'paid',
				label: 'Paid',
				amount: 0
			}
		];
	}
	public static getInputControlTypeInputOne() 
	{
		return [
			new Control({
				id: '9e42775d-7ea0-4dc0-ab16-7fb9d013ac31',
				label: '',
				type: ControlType.input,
				inputPlaceholderText: '',
				inputIcon: '',
				options: [],
				value: ''
			})
		];
	}
	public static getInputControlTypeRadioOne() 
	{
		return [new Control({
			id: '9e42775d-7ea0-4dc0-ab16-7fb9d013ac31',
			label: '',
			type: ControlType.radio,
			inputPlaceholderText: '',
			inputIcon: '',
			options: [
				{
					label: '',
					value: '',
					checked: false
				}
			],
			value: ''
		})];
	}
	public static getFooterMenuDefault() 
	{
		return [
			{
				id: '',
				label: '',
				iconPath: '',
				altText: '',
				labelValue: [],
				url: ''
			},
			{
				id: '',
				label: '',
				iconPath: '',
				altText: '',
				labelValue: [],
				url: ''
			},
			{
				id: '',
				label: '',
				iconPath: '',
				altText: '',
				labelValue: [],
				url: ''
			},
			{
				id: '',
				label: '',
				iconPath: '',
				altText: '',
				labelValue: [],
				url: ''
			}
		];
	}
	public static getCtaListCancelApply() 
	{
		return [
			{
				id: '327147f4-c044-4799-8a5a-d075c619e41c',
				label: 'Cancel',
				className: 'light',
				disabled: false
			},
			{
				id: '7eeaa3f0-b4f6-4142-8086-361298d75686',
				label: 'Apply',
				className: 'dark',
				disabled: false
			}
		];
	}
	public static buildTableData(): KngCardListState 
	{
		return {
			view:
				window.innerWidth >= 768
					? ScreenView.tableDesktop
					: ScreenView.tableMobile,
			header: [],
			list: [],
			cardListGrayIcon: { url: '', alt: '' },
			cardListOrangeIcon: { url: '', alt: '' },
			cardListAccordionIcon: { url: '', alt: '' },
			actionOpsList: [],
			pageInfo: {
				pageSize: 0,
				totalCount: 0
			},
			error: {
				message: '',
				messageSubText: '',
				icon: Icons.noResult
			},
			loading: false,
			hideSort: false
		};
	}
	public static buildGridData(): GridValue[] 
	{
	
		return [
			{
				values: [
					{ label: '', value: '', ctaList: [] },
					{ label: '', value: '', ctaList: [] },
					{ label: '', value: '', ctaList: [] },
					{ label: '', value: '', ctaList: [] }
				],
				id: '',
				email: '',
				state: '',
				company: '',
				roles: [],
				portalApprovedCustomerID: [],
				phoneNumber: '',
				roleName: ''
			}
		];
		
	}
	public static buildTableDataAccordion(): KngCardListState 
	{
		return {
			view:
        window.innerWidth >= 768
        	? ScreenView.accordionDeskTop
        	: ScreenView.accordionMobile,
			header: [],
			list: [],
			cardListGrayIcon: { url: '', alt: '' },
			cardListOrangeIcon: { url: '', alt: '' },
			cardListAccordionIcon: { url: '', alt: '' },
			actionOpsList: [],
			pageInfo: {
				pageSize: 0,
				totalCount: 0
			},
			error: {
				message: '',
				messageSubText: '',
				icon: Icons.noResult
			},
			loading: true,
			hideSort: false
		};
	}
	public static getDefaultSearchLocation() 
	{
		return {
			accordionIconExpanded: {
				iconPath: '',
				altText: ''
			},
			accordionIconCollapsed: {
				iconPath: '',
				altText: ''
			},
			label: 'Location',
			searchPlaceholder: 'Search',
			searchIcon: {
				iconPath: '',
				altText: ''
			},
			noResultsFoundLabel: 'No matching locations found',
			showMore: '',
			showLess: '',
			errorMessage: ''
		};
	}
	public static getDefaultDateRange() 
	{
		return {
			accordionIconExpanded: {
				iconPath: '',
				altText: ''
			},
			accordionIconCollapsed: {
				iconPath: '',
				altText: ''
			},
			label: '',
			values: [],
			customDateFromLabel: '',
			customDateToLabel: ''
		};
	}
	public static getDefaultKeyValueId() 
	{
		return {
			key: '',
			value: '',
			id: ''
		};
	}
	public static getDivisionGroupFilter()
	{
		return {
			label: '',
			accordionIconExpanded: {
				iconPath: '',
				altText: ''
			},
			accordionIconCollapsed: {
				iconPath: '',
				altText: ''
			},
			search: {
				placeholder: '',
				icon: {
					iconPath: '',
					altText: ''
				}
			},
			noResultsFoundLabel: '',
			showMoreText: '',
			showLessText: ''
		};
	}
	public static getKngFilterState(type: string): KngFilterState 
	{
		return {
			filterData: {
				heading: { label: '' },
				sections: [
					{
						label: 'Date Range',
						controls: [
							new Control({
								id: '9e42775d-7ea0-4dc0-ab16-7fb9d013ac31',
								label: '',
								type: ControlType.radio,
								inputPlaceholderText: '',
								inputIcon: '',
								options: [
									{
										label: '',
										value: '',
										checked: false
									}
								],
								value: ''
							})
						],
						accordionCollapsedIcon: this.getAccordionCollapsedIcon(),
						accordionExpandedIcon: this.getAccordionExpandedIcon(),
						searchIcon: this.getSearchIcon(),
						crossIcon: this.getSearchCrossIcon(),
						collapsed: true
					},
					{
						label: 'Location',
						controls: (type === 'input') ? this.getInputControlTypeInputOne() : this.getInputControlTypeRadioOne(),
						accordionCollapsedIcon: this.getAccordionCollapsedIcon(),
						accordionExpandedIcon: this.getAccordionExpandedIcon(),
						searchIcon: this.getSearchIcon(),
						crossIcon: this.getSearchCrossIcon(),
						collapsed: false
					}

				],
				ctaList: [
					{
						id: '327147f4-c044-4799-8a5a-d075c619e41c',
						label: 'Clear All',
						className: 'light',
						disabled: true
					},
					{
						id: '7eeaa3f0-b4f6-4142-8086-361298d75686',
						label: 'Apply',
						className: 'dark',
						disabled: false
					}
				]
			},
			hidden: true
		};
	}
	public static getKngFilterStateForEquipmentOrder(type: string): KngFilterState 
	{
		return {
			filterData: {
				heading: { label: '' },
				sections: [
					{
						label: 'Date Range',
						controls: [
							new Control({
								id: '9e42775d-7ea0-4dc0-ab16-7fb9d013ac31',
								label: '',
								type: ControlType.radio,
								inputPlaceholderText: '',
								inputIcon: '',
								options: [
									{
										label: '',
										value: '',
										checked: false
									}
								],
								value: ''
							})
						],
						accordionCollapsedIcon: this.getAccordionCollapsedIcon(),
						accordionExpandedIcon: this.getAccordionExpandedIcon(),
						searchIcon: this.getSearchIcon(),
						crossIcon: this.getSearchCrossIcon(),
						collapsed: true
					},
					SharedFilterFactory.buildDivisionOrGroupSection(),
					SharedFilterFactory.buildDivisionOrGroupSection(),
					{
						label: 'Location',
						controls: (type === 'input') ? this.getInputControlTypeInputOne() : this.getInputControlTypeRadioOne(),
						accordionCollapsedIcon: this.getAccordionCollapsedIcon(),
						accordionExpandedIcon: this.getAccordionExpandedIcon(),
						searchIcon: this.getSearchIcon(),
						crossIcon: this.getSearchCrossIcon(),
						collapsed: false
					},
					{
						label: 'Location',
						controls: (type === 'input') ? this.getInputControlTypeInputOne() : this.getInputControlTypeRadioOne(),
						accordionCollapsedIcon: this.getAccordionCollapsedIcon(),
						accordionExpandedIcon: this.getAccordionExpandedIcon(),
						searchIcon: this.getSearchIcon(),
						crossIcon: this.getSearchCrossIcon(),
						collapsed: false
					}

				],
				ctaList: [
					{
						id: '327147f4-c044-4799-8a5a-d075c619e41c',
						label: 'Clear All',
						className: 'light',
						disabled: true
					},
					{
						id: '7eeaa3f0-b4f6-4142-8086-361298d75686',
						label: 'Apply',
						className: 'dark',
						disabled: false
					}
				]
			},
			hidden: true
		};
	}
	public static getEquipmentOrderFilterState(type: string): KngFilterState 
	{
		const section = {
			label: 'Shipping Location',
			controls: (type === 'input') ? this.getInputControlTypeInputOne() : this.getInputControlTypeRadioOne(),
			accordionCollapsedIcon: this.getAccordionCollapsedIcon(),
			accordionExpandedIcon: this.getAccordionExpandedIcon(),
			searchIcon: this.getSearchIcon(),
			crossIcon: this.getSearchCrossIcon(),
			collapsed: false
		};
		const state = this.getKngFilterStateForEquipmentOrder('input');
		state.filterData.sections[4] = section;
		return state;
	}
	public static getMyDealerDefault() 
	{
		return {
			firstName: nullCheckValue,
			lastName: '',
			phone: {
				label: '',
				value: nullCheckValue,
				icon: {
					iconPath: '',
					altText: ''
				}
			},
			email: {
				label: '',
				value: nullCheckValue,
				icon: {
					iconPath: '',
					altText: ''
				}
			},
			address: {
				label: '',
				value: {
					addressLine1: nullCheckValue,
					addressLine2: '',
					city: '',
					state: '',
					zipCode: ''
				},
				icon: {
					iconPath: '',
					altText: ''
				}

			}
		};
	}

	public static buildImage(iconPath: string, altText: string): Image
	{
		return {
			iconPath: iconPath,
			altText: altText
		};
	}

	public static buildHeaderItem(isSelected: boolean, image: Image, url: string, label: string, cssClass: string, id: string, submenu: Array<KngHeaderNavMenuOption>, hideMenu:boolean=true)
	{
		return {
			isSelected: isSelected,
			iconPath: image.iconPath,
			altText: image.altText,
			url: url,
			label: label,
			cssClass: cssClass,
			id: id,
			submenu: submenu,
			hideMenu: hideMenu
		};
	}
	public static buildCTAButtonList(): CtaList[]
	{
		return [
			{
				id: '',
				className: AprRejBtnType.bulkApprove,
				state: {
					size: 'medium',
					style: 'link',
					disabled: false,
					label: '',
					icon: { altText: '', iconPath: '' },
					position: 'none'
				}
			},
			{
				id: '',
				className: AprRejBtnType.bulkReject,
				state: {
					size: 'medium',
					style: 'link',
					disabled: false,
					label: '',
					icon: { altText: '', iconPath: '' },
					position: 'none'
				}
			}
		];
	}
	public static buildKngButton(): KngButtonState
	{
		return {
			size: 'medium',
			style: 'link',
			disabled: false,
			label: '',
			icon: { altText: '', iconPath: '' },
			position: 'none'
		};
	}
	public static buildGlobalHeader(): GlobalHeader[]
	{
		return [
			{
				isSelected: false,
				iconPath: '',
				altText: '',
				url: '',
				label: '',
				cssClass: '',
				id: '2708cc73-d48c-4301-afa3-ee0bb03002b6',
				submenu: []
			},
			{
				isSelected: false,
				iconPath: '',
				altText: '',
				url: '',
				label: '',
				cssClass: '',
				id: '990cdcf6-5612-4d14-9fca-468553692947',
				submenu: []
			}
		];
	}
	public static buildTableList(page:string) : KngCardListState
	{
		return{
			view: ScreenView.accordionDeskTop,
			header: this.getTableHeader(page),
			cardListAccordionIcon: { url: '', alt: '' },
			cardListGrayIcon: { url: '', alt: '' },
			cardListOrangeIcon: { url: '', alt: '' },
			pageInfo: { pageSize: 0, totalCount: 0 },
			tooltipMessage: '',
			serviceCampaignAltText: '',
			moreIconAltText: '',
			list: [{ collapsed: false, values: [], id: '' }],
			loading: true,
			activeFlag: ''
		};
	}

	public static getTableHeader(page:string): Array<KngHeaderObjState>
	{
		if(page === 'MyQuotes')
		{
			return [
				{
					label: 'Quote #', isSort: true, sortOrder: SortOrder.desc
				},
				{
					label: 'Date Created', isSort: true, sortOrder: SortOrder.desc
				},
				{
					label: 'Model', isSort: true, sortOrder: SortOrder.desc
				},
				{
					label: 'Quantity', isSort: true, sortOrder: SortOrder.desc
				},
				{
					label: 'Billing Address', isSort: true, sortOrder: SortOrder.desc
				},
				{
					label: 'Status', isSort: true, sortOrder: SortOrder.desc
				}
			];
		}
		else if(page === 'ServiceManagement')
		{
			return[
				{
					label: 'Service Date',
					isSort: true,
					sortOrder: SortOrder.desc
				},
				{
					label: 'Work Order #',
					isSort: true,
					sortOrder: SortOrder.desc
				},
				{
					label: 'PO',
					isSort: true,
					sortOrder: SortOrder.desc
				},
				{
					label: 'Billing Address',
					isSort: true,
					sortOrder: SortOrder.desc
				},
				{
					label: 'Service Address',
					isSort: true,
					sortOrder: SortOrder.desc
				},
				{
					label: 'Cost',
					isSort: true,
					sortOrder: SortOrder.desc,
					hideSort: true
				},
				{
					label: 'Payment Status',
					isSort: true,
					sortOrder: SortOrder.desc,
					hideSort: true
				},
				{
					label: 'Invoice',
					isSort: true,
					sortOrder: SortOrder.desc,
					hideSort: true
				}
			];
		}
		else if (page === 'User Management')
		{
			return [
				{ label: 'Name', isSort: true, sortOrder: SortOrder.asc },
				{ label: 'Email', isSort: true, sortOrder: SortOrder.asc },
				{ label: 'Role', isSort: true, sortOrder: SortOrder.desc },
				{ label: 'Assigned Location', isSort: true, sortOrder: SortOrder.desc },
				{ label: 'Last Login', isSort: true, sortOrder: SortOrder.desc },
				{ label: 'Status', isSort: true, sortOrder: SortOrder.desc }
			];
		}
		return [];
	}
	public static getRoleList(): UserDetailMiddle
	{
		return {
			rolesList: [{ id: '', name: '', description: '' }],
			status: [],
			roleDescription: '',
			isStatusUpdatePending: false,
			statusUpdatePendingMessage: '',
			isStatusUpdateError: false,
			statusUpdateErrorState: {
				errorIcon: this.buildImage('', ''),
				message: ''
			}
		};		
	}
	public static getUserDetail() 
	{
		return{
			heading: '',
			description: '',
			descriptionBold: '',
			descriptionCompanyAdmin: '',
			assignNewLocation: '',
			helpText: '',
			searchPlaceholder: '',
			searchIcon: {
				iconPath: '',
				altText: ''
			},
			grid: [
				{
					locationid: '',
					location: '',
					address: '',
					checked: false
				}
			],
			cancel: '',
			unassignlocation: 'Unassign Locations',
			noLocationFoundTableLabel: '',
			noLocationFoundTableMsg: '',
			noLocationFoundTableIcon: {
				iconPath: '/assets/unassignedLocation.svg',
				altText: ''
			},
			noResult: {
				icon: {
					iconPath: '',
					altText: ''
				},
				messageBold: ''
			},
			filterDropdownState: {
				filterOptions: [
					{
						key: '',
						value: ''
					}
				],
				selectedOption: ''
			}
		};
	}
}
